exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".class-header[data-v-0c1b466f]{padding-bottom:40px}.class-header.boder[data-v-0c1b466f]{border-bottom:1px solid #e6e6e6}.class-header .m[data-v-0c1b466f]{font-size:24px;font-weight:500;line-height:32px;word-break:break-all}.class-header .s[data-v-0c1b466f]{margin-top:17px;font-size:14px;color:#666;line-height:20px;word-break:break-all}.class-header .ext-bar[data-v-0c1b466f]{color:#666;margin-top:18px}.class-header .ext-bar .ext-bar-label[data-v-0c1b466f]{font-size:12px}.class-header .ext-bar .ext-bar-label .ico[data-v-0c1b466f]{-webkit-transform:scale(.8);transform:scale(.8);display:inline-block;margin-right:5px}", ""]);

// exports
